var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37545 18.7148H20.6245C21.478 18.7148 22 18.2683 22 17.5985C22 16.7533 21.2046 16.0277 20.4588 15.3419C19.8705 14.7917 19.738 13.6435 19.6302 12.583C19.4977 9.66463 18.6111 7.60741 16.465 6.86585C16.1253 5.81332 15.2222 5 13.9959 5C12.7778 5 11.8747 5.81332 11.5267 6.86585C9.38892 7.60741 8.49404 9.66463 8.36976 12.583C8.26204 13.6435 8.12118 14.7917 7.54117 15.3419C6.79544 16.0277 6 16.7533 6 17.5985C6 18.2683 6.52201 18.7148 7.37545 18.7148ZM13.9959 22C15.4707 22 16.5396 20.9873 16.6473 19.8311H11.3527C11.4604 20.9873 12.5293 22 13.9959 22Z",
    fill: "#797AF2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedselected);
export default __webpack_public_path__ + "static/media/feedselected.4b100a98fe1d60c9e864b055e1ad9de5.svg";
export { ForwardRef as ReactComponent };